import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Typewriter } from 'react-simple-typewriter';
import Marquee from 'react-fast-marquee';
import { RegistrationForm } from './RegistrationForm';
import { ErrorBoundary } from './ErrorBoundary';
export function HeroSection() {
  // Calculate countdown to a date 2 weeks from now
  const [timeLeft, setTimeLeft] = useState({
    days: 10,
    hours: 0,
    minutes: 0
  });
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + 6);
    const interval = setInterval(() => {
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
      setTimeLeft({
        days,
        hours,
        minutes
      });
      if (difference <= 0) {
        clearInterval(interval);
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0
        });
      }
    }, 1000);
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      clearInterval(interval);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <div className="w-full bg-gradient-to-b from-[#5590bc] to-[#2f5f98] relative overflow-hidden" data-id="element-297">
      {/* Navigation */}
      <nav className="w-full flex justify-center items-center py-6 relative z-10 bg-white shadow-sm" data-id="element-298">
        <div className="max-w-6xl w-full mx-auto px-4 flex justify-between items-center" data-id="element-299">
          <div className="flex items-center" data-id="element-300">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ojY6WmRCgegYFFMNPUoA8J/logo.png" alt="The Product Compass Logo" className="h-6 mr-2" data-id="element-301" />
            <div className="text-[#292929] font-bold text-xl" data-id="element-302">
              The Product Compass - #1 AI & Product Newsletter
            </div>
          </div>
        </div>
      </nav>
      {/* Hero Content - Split Screen Layout */}
      <div className="max-w-6xl mx-auto px-4 py-12 md:py-12 flex flex-col md:flex-row items-center relative z-10 pb-4" data-id="element-303">
        {/* Left Side - Content */}
        <div className="w-full md:w-1/2 mb-10 md:mb-0 pr-0 md:pr-8" data-id="element-304">
          {/* Status badge */}
          <div className="inline-block bg-[#ff8a14] px-4 py-2 mb-6 font-bold text-sm md:text-base rounded-md shadow-lg animate-pulse" data-id="element-305">
            <span className="inline-block text-white  w-2 h-2 rounded-full bg-white mr-2" data-id="element-306"></span>
            Kickoff • January 2026
          </div>
          {/* Main heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 leading-tight" data-id="element-307">
            AI AGENTS
            <br data-id="element-308" />
            <span className="text-[#ff8a14]" data-id="element-309">BUILDATHON</span>
          </h1>
          {/* Subtitle */}
          <p className="text-xl text-white mb-8" data-id="element-310">
            Build a standout AI Product Management portfolio in 3 weeks - Skip
            the line to your{' '}
            <span className="text-[#ff8a14] font-semibold" data-id="element-311">
              <ErrorBoundary fallback={<span data-id="element-313">dream AI PM role</span>} data-id="element-312">
                <Typewriter words={['dream AI PM role', 'AI skill boost', 'next career move', 'AI PM leadership role']} loop={true} cursor cursorStyle="_" typeSpeed={70} deleteSpeed={50} delaySpeed={1000} data-id="element-314" />
              </ErrorBoundary>
            </span>
            .
          </p>
          {/* Bullet Points */}
          <div className="mb-8 space-y-4" data-id="element-315">
            <div className="flex items-start" data-id="element-316">
              <CheckCircle2Icon className="w-6 h-6 text-[#f7f7f7] mt-0.5 mr-3 flex-shrink-0" data-id="element-317" />
              <p className="text-white" data-id="element-318">
                Join a team of 3 to collaborate and co-create/ or work solo
              </p>
            </div>
            <div className="flex items-start" data-id="element-319">
              <CheckCircle2Icon className="w-6 h-6 text-[#f7f7f7] mt-0.5 mr-3 flex-shrink-0" data-id="element-320" />
              <p className="text-white" data-id="element-321">
                Get team mentorship from senior AI product managers
              </p>
            </div>
            <div className="flex items-start" data-id="element-322">
              <CheckCircle2Icon className="w-6 h-6 text-[#f7f7f7] mt-0.5 mr-3 flex-shrink-0" data-id="element-323" />
              <p className="text-white" data-id="element-324">
                Showcase your skills to 350K+ product pros and AI teams scouting
                for talent
              </p>
            </div>
            <div className="flex items-start" data-id="element-325">
              <CheckCircle2Icon className="w-6 h-6 text-[#f7f7f7] mt-0.5 mr-3 flex-shrink-0" data-id="element-326" />
              <p className="text-white" data-id="element-327">
                Earn an official certificate from The Product Compass
              </p>
            </div>
          </div>
          {/* CTA button */}
          <div className="mb-8" data-id="element-328">
            <div className="mt-4" data-id="element-329"></div>
          </div>
          {/* Social proof logos */}
          <div className="mb-6" data-id="element-330">
            <p className="text-white text-sm mb-3 opacity-80" data-id="element-331">
              TRUSTED BY PROFESSIONALS
            </p>
            <div className="flex flex-col space-y-2" data-id="element-332">
              <div className="flex -space-x-3" data-id="element-333">
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&auto=format&fit=crop&q=80" alt="User avatar" className="w-10 h-10 rounded-full border-2 border-white object-cover" data-id="element-334" />
                <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&auto=format&fit=crop&q=80" alt="User avatar" className="w-10 h-10 rounded-full border-2 border-white object-cover" data-id="element-335" />
                <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&auto=format&fit=crop&q=80" alt="User avatar" className="w-10 h-10 rounded-full border-2 border-white object-cover" data-id="element-336" />
                <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&auto=format&fit=crop&q=80" alt="User avatar" className="w-10 h-10 rounded-full border-2 border-white object-cover" data-id="element-337" />
                <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&auto=format&fit=crop&q=80" alt="User avatar" className="w-10 h-10 rounded-full border-2 border-white object-cover" data-id="element-338" />
                <div className="w-10 h-10 rounded-full border-2 border-white bg-[#ff8a14] flex items-center justify-center text-white text-xs font-bold" data-id="element-339">
                  +24
                </div>
              </div>
              <div className="flex items-center" data-id="element-340">
                <div className="flex mr-2" data-id="element-341">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 text-[#ff8a14] fill-current" viewBox="0 0 24 24" data-id="element-342">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-343" />
                    </svg>)}
                </div>
                <span className="text-white text-sm" data-id="element-344">
                  <span className="font-bold" data-id="element-345">4.9/5</span> from{' '}
                  <span className="font-bold" data-id="element-346">126,000+</span> members of The
                  Product Compass worldwide
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* Right Side - Registration Form */}
        <div className="w-full md:w-1/2 flex justify-center" data-id="element-347">
          <div className="relative w-full max-w-md" data-id="element-348">
            <div className="absolute -top-10 -left-10 w-20 h-20 bg-[#ff8a14] opacity-20 rounded-full" data-id="element-349"></div>
            <div className="absolute -bottom-5 -right-5 w-16 h-16 bg-white opacity-20 rounded-full" data-id="element-350"></div>
            {/* Registration Form */}
            <div id="register" data-id="element-351">
              <RegistrationForm data-id="element-352" />
            </div>
          </div>
        </div>
      </div>
      {/* Marquee Ticker - Brand Names */}
      <ErrorBoundary fallback={<div className="w-full bg-white bg-opacity-5 backdrop-filter backdrop-blur-sm py-2 border-t border-white border-opacity-10" data-id="element-354">
            <div className="flex items-center justify-center space-x-12 px-6" data-id="element-355">
              <div className="text-white font-medium text-xl opacity-60" data-id="element-356">
                N8N
              </div>
              <div className="text-white font-medium text-xl opacity-60" data-id="element-357">
                LOVABLE
              </div>
              <div className="text-white font-medium text-xl opacity-60" data-id="element-358">
                OPENAI
              </div>
              <div className="text-white font-medium text-xl opacity-60" data-id="element-359">
                STRIPE
              </div>
              <div className="text-white font-medium text-xl opacity-60" data-id="element-360">
                SUPABASE
              </div>
            </div>
          </div>} data-id="element-353">
        <div className="w-full bg-white bg-opacity-5 backdrop-filter backdrop-blur-sm py-2 border-t border-white border-opacity-10" data-id="element-361">
          <div className="text-center mb-1" data-id="element-362"></div>
          <Marquee gradient={false} speed={40} data-id="element-363">
            <div className="flex items-center space-x-12 px-6" data-id="element-364">
              <div className="text-white font-medium text-xl opacity-60 mx-6" data-id="element-365">
                N8N
              </div>
              <div className="text-white font-medium text-xl opacity-60 mx-6" data-id="element-366">
                LOVABLE
              </div>
              <div className="text-white font-medium text-xl opacity-60 mx-6" data-id="element-367">
                OPENAI
              </div>
              <div className="text-white font-medium text-xl opacity-60 mx-6" data-id="element-368">
                STRIPE
              </div>
              <div className="text-white font-medium text-xl opacity-60 mx-6" data-id="element-369">
                SUPABASE
              </div>
            </div>
          </Marquee>
        </div>
      </ErrorBoundary>
      {/* Background elements */}
      <div className="absolute top-20 right-10 w-64 h-64 bg-[#ff8a14] opacity-5 rounded-full blur-3xl" data-id="element-370"></div>
      <div className="absolute bottom-20 left-10 w-80 h-80 bg-white opacity-5 rounded-full blur-3xl" data-id="element-371"></div>
      <div className="absolute top-1/3 left-1/4 w-48 h-48 bg-[#00b3b1] opacity-5 rounded-full blur-3xl" data-id="element-372"></div>
    </div>;
}